var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D2065B67-C19B-42D6-8408-D53DD5A578F7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M143.6875,489 C138.335938,489 134,493.335938 134,498.6875 C134,504.039063 138.335938,508.375 143.6875,508.375 C149.039063,508.375 153.375,504.039063 153.375,498.6875 C153.375,493.335938 149.039063,489 143.6875,489 Z M149.3125,499.78125 C149.3125,500.039063 149.101563,500.25 148.84375,500.25 L145.25,500.25 L145.25,503.84375 C145.25,504.101563 145.039063,504.3125 144.78125,504.3125 L142.59375,504.3125 C142.335938,504.3125 142.125,504.101563 142.125,503.84375 L142.125,500.25 L138.53125,500.25 C138.273438,500.25 138.0625,500.039063 138.0625,499.78125 L138.0625,497.59375 C138.0625,497.335938 138.273438,497.125 138.53125,497.125 L142.125,497.125 L142.125,493.53125 C142.125,493.273438 142.335938,493.0625 142.59375,493.0625 L144.78125,493.0625 C145.039063,493.0625 145.25,493.273438 145.25,493.53125 L145.25,497.125 L148.84375,497.125 C149.101563,497.125 149.3125,497.335938 149.3125,497.59375 L149.3125,499.78125 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-KIt",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-134.000000, -489.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "plus-circle",
    fill: "#7C809B",
    fillRule: "nonzero",
    transform: "translate(143.687500, 498.687500) rotate(-315.000000) translate(-143.687500, -498.687500) ",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default ForwardRef;